import { setupGlobals, setupClientGlobals } from '../util/GlobalSetup.js';
setupClientGlobals();
setupGlobals();

import '../chunks/actions-webcomponents.js';
import '../chunks/polyfills.js';
import '../chunks/spectrum-webcomponents.js';
import '../chunks/shared-webcomponents.js';
import 'angular';
import '../spectrum/app.js';
import { switchLocale } from '../i18n/spectrum.i18n.js';
import { initI18n } from '../util/i18n_util.js';
import { initFlipper } from '../util/flipper.js';
import { loadGlyphMapSectionModule } from '../components/glyphMap/activationTelemetry.ts';
import { initGlyphMapAnalytics } from '../components/glyphMap/analytics.ts';
import { startResourceTimingRetention } from '../components/glyphMap/resourceTimingRetention.ts';
import { isPhone } from '../util/is_phone.js';

// Redirect the user to the new favorites page from the my_fonts#favorites-section page
if (window && window.location.pathname.includes('my_fonts') && window.location.hash.includes('favorites')) {
  window.location.replace('/fonts?your_fonts=favorite');
}

initGlyphMapAnalytics();
// Cached HTML includes the mount on phones; skip its import before Angular removes it.
if (!isPhone() && document.querySelector('af-glyph-map-section')) {
  startResourceTimingRetention();
  void loadGlyphMapSectionModule(() => import('../components/GlyphMapSection.ts'));
}

// Same deal for the OpenType features panel (FONTS-20479): its mount point is
// only in the page when :enable_opentype_features is on for the current user.
if (document.querySelector('af-opentype-features-section')) {
  void import('../components/OpenTypeFeaturesSection.ts');
}

initI18n(switchLocale);
initFlipper();
